import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  AgrDaterangePickerModule,
  AgrPageToolbarModule,
  AgrSummaryCardHorizontalModule,
  AgrSummaryCardModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrTableModule } from '@next/core-lib/table';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { DeliveriesComponent } from './components/deliveries/deliveries.component';
import { RationsComponent } from './components/rations/rations.component';
import { SilageResultsComponent } from './components/silage-results/silage-results.component';
import { FeedEffects } from './store/effects/feed.effects';
import { feedReducer } from './store/reducers/feed.reducers';

@NgModule({
  imports: [
    AgrDaterangePickerModule,
    AgrDialogModule,
    AgrFormModule,
    AgrPageToolbarModule,
    AgrSummaryCardModule,
    AgrSummaryCardHorizontalModule,
    AgrTableModule,
    CommonModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatSlideToggleModule,
    SharedModule,
    DeliveriesComponent,
    RationsComponent,
    SilageResultsComponent,
  ],
  providers: [provideState('feed', feedReducer), provideEffects([FeedEffects])],
})
export class FeedModule {}
